import { styles } from './template.scss';

export const templateLiveSearchMetadata = document.createElement('template');

templateLiveSearchMetadata.innerHTML = `
  <style>${styles}</style>
  <div class="wrapper">
    <div class="gz-metadata-header-disabled" id="gz-metadata-header">
      <div>
        <span id="title-text"></span>
      </div>
      <div class="gz-metadata-details">
        <div>
          <span id="status-text"></span>
          <span id="status-value" class="metadata-header-values"></span>
        </div>
        <div>
          <span id="respondents-text"></span>
          <span id="respondents-value" class="metadata-header-values"></span>
        </div>
        <div>
          <span id="total-endpoints-text"></span>
          <span id="total-endpoints-value" class="metadata-header-values"></span>
        </div>
      </div>
      <div>
        <button class="gz-metadata-view-more-button"></button>
      </div>
    </div>
  </div>
`;
